import * as React from 'react'

export const Salary = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_431_697)">
      <path
        d="M5.75586 63.4239L21.5414 69.2994C22.8821 69.7984 24.3011 70.054 25.7316 70.054H41.9998C44.2764 70.054 46.5061 69.4071 48.4292 68.1885L68.7986 55.2813C70.1425 54.088 70.3916 52.0826 69.3806 50.5967C68.2743 48.971 66.4444 48.6885 64.4307 49.6406L44.5991 58.3725L44.6226 55.155C44.3599 52.514 42.3265 50.3945 39.6988 50.0228L27.622 48.6323C24.8361 48.2381 23.444 47.3045 21.0153 45.8838C17.6996 43.9442 13.9273 42.9219 10.086 42.9219H5.75586V63.4239Z"
        fill="#FFDDCE"
      />
      <path
        d="M20.5827 66.1687C21.9921 66.6933 23.4839 66.962 24.9878 66.962H42.09C43.9107 66.962 45.7024 66.5674 47.3458 65.8151L59.3045 58.2373C60.4156 57.5332 61.1209 56.3077 61.0848 54.9929C61.0656 54.2956 60.8525 53.5976 60.4349 52.984C60.4349 52.984 60.0708 52.3601 59.6967 51.725L44.5991 58.3725L44.6226 55.155C44.3599 52.514 42.3265 50.3945 39.6988 50.0228L27.622 48.6323C24.836 48.2381 23.444 47.3045 21.0153 45.8838C17.6996 43.9442 13.9273 42.9219 10.086 42.9219H5.75586V60.65L20.5827 66.1687Z"
        fill="#FFEDEB"
      />
      <path
        d="M69.3804 50.5965C68.2742 48.9707 66.4442 48.6882 64.4305 49.6403L58.9757 52.0421C59.2399 52.4603 59.45 52.794 59.45 52.794C60.461 54.2799 60.2119 56.2853 58.868 57.4786L46.9991 64.9994C45.4359 65.715 43.7315 66.0904 41.9995 66.0904H25.7316C24.3011 66.0904 22.8821 65.8348 21.5414 65.3358L5.75586 59.4601V63.4235L21.5414 69.2991C22.8821 69.7982 24.3011 70.0537 25.7316 70.0537H39.0229H41.9999C44.2765 70.0537 46.5063 69.4068 48.4294 68.1882L68.7987 55.2811C70.1424 54.0877 70.3916 52.0822 69.3804 50.5965Z"
        fill="#FFDDD9"
      />
      <path
        d="M43.1422 51.8398L43.1416 51.9175L43.1928 51.8949C43.1762 51.8763 43.159 51.8583 43.1422 51.8398Z"
        fill="#F5DBCC"
      />
      <path
        d="M44.599 58.3701H32.2678C31.6656 58.3701 31.1775 57.8821 31.1775 57.2798C31.1775 56.6775 31.6655 56.1895 32.2678 56.1895H44.615L44.599 58.3701Z"
        fill="#FFDDD9"
      />
      <path
        d="M9.15271 66.5686C9.15271 67.7139 8.22426 68.6424 7.0789 68.6424H2.07381C0.928452 68.6424 0 67.7139 0 66.5686V41.1754C0 40.03 0.928452 39.1016 2.07381 39.1016H7.0789C8.22426 39.1016 9.15271 40.03 9.15271 41.1754V66.5686Z"
        fill="#C8A09B"
      />
      <path
        d="M53.8943 20.0091V41.5873C53.8943 42.3393 53.3037 42.9303 52.5519 42.9303H25.7037C24.9519 42.9303 24.3613 42.3393 24.3613 41.5873V22.1041C24.3613 21.6206 24.6297 21.1909 25.0325 20.9491L28.6569 18.854C28.8718 18.7196 29.1134 18.666 29.3281 18.666H35.1006L39.1278 22.1041L43.155 18.666H52.5519C53.3037 18.666 53.8943 19.2569 53.8943 20.0091Z"
        fill="#F3CBC6"
      />
      <path
        d="M53.8939 20.0091V41.5873C53.8939 42.3393 53.3034 42.9303 52.5515 42.9303H39.1274V22.1041L43.1547 18.666H52.5515C53.3034 18.666 53.8939 19.2569 53.8939 20.0091Z"
        fill="#C9A19C"
      />
      <path
        d="M50.7525 7.65235L46.7253 0.668536C46.3494 0.0238764 45.5171 -0.19101 44.8728 0.185041L39.1273 3.51578L38.3581 3.9597L23.0923 12.7719L16.9776 16.3016C16.3332 16.6508 16.0289 17.4835 16.4048 18.1282L20.5215 25.112C20.8974 25.7567 21.7028 25.9715 22.3472 25.5954L39.1273 15.8987L50.2424 9.47889C50.8868 9.10302 51.1016 8.29719 50.7525 7.65235Z"
        fill="#D8B0AB"
      />
      <path
        d="M50.2426 9.47889L39.1274 15.8986V3.51578L44.8729 0.185041C45.5173 -0.19101 46.3496 0.0238764 46.7255 0.668536L50.7527 7.65226C51.1018 8.29719 50.8869 9.10293 50.2426 9.47889Z"
        fill="#CFA7A2"
      />
    </g>
    <defs>
      <clipPath id="clip0_431_697">
        <rect width="70" height="70" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
